<template>
	<Popconfirm
		:title="title"
		:ok-text="okText"
		:cancel-text="cancelText"
		:placement="placement"
		:disabled="disabled"
		:getPopupContainer="popupContainerFunction"
		@confirm="onConfirm"
		overlayClassName="max-width-normal"
		:okButtonProps="{ danger: isDangerousOperation }"
	>
		<template #title>
			<slot name="title" />
		</template>
		<template v-if="isDangerousOperation" #icon>
			<ExclamationCircleOutlined style="color: red" />
		</template>
		<Button
			:class="buttonClass"
			:type="type"
			:loading="loading"
			:disabled="disabled"
			:size="size"
		>
			<slot name="icon" />
			<slot />
		</Button>
	</Popconfirm>
</template>

<script>
import { toRef, computed } from 'vue';
import { Popconfirm, Button } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

import { usePopupContainer } from '@/utils/usePopupContainer';


export default {
	components: {
		Popconfirm, Button, ExclamationCircleOutlined,
	},
	props: {
		title: {
			type: String,
			required: false,
		},
		okText: {
			type: String,
			required: true,
		},
		cancelText: {
			type: String,
			required: true,
		},
		placement: {
			type: String,
			required: false,
			default: 'top',
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		type: {
			type: String,
			required: false,
			default: 'default',
		},
		loading: {
			type: Boolean,
			required: false,
			default: false,
		},
		size: {
			type: String,
			required: false,
			default: 'middle',
		},
		buttonClass: {
			type: String,
			required: false,
			default: '',
		},
		onConfirm: {
			type: Function,
			required: true,
		},
		getPopupContainer: {
			type: Function,
			required: false,
		},
		isDangerousOperation: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup(props) {
		const getPopupContainerRef = toRef(props, 'getPopupContainer');
		const { getPopupContainer } = usePopupContainer();
		const popupContainerFunction = computed(() => {
			if (getPopupContainerRef.value != null) {
				return getPopupContainerRef.value;
			}
			return getPopupContainer;
		});
		return {
			popupContainerFunction,
		};
	},
}
</script>
